import { render, staticRenderFns } from "./priceDistribution.vue?vue&type=template&id=5bf7256a&scoped=true&"
import script from "./priceDistribution.vue?vue&type=script&lang=js&"
export * from "./priceDistribution.vue?vue&type=script&lang=js&"
import style0 from "./priceDistribution.vue?vue&type=style&index=0&id=5bf7256a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf7256a",
  null
  
)

export default component.exports